(function () {
  'use strict';

  const script =
    document.currentScript ||
    document.querySelector(
      'script[src*="elyra-personalization.js"]'
    );

  const ADDON_VARIANT_ID = Number(
    script?.dataset?.addonVariantId ||
    '10401895350601'
  );

  const TEMPLATE =
    String(script?.dataset?.template || '');

  /*
   * Custom bag are deja configurator separat.
   */
  if (
    TEMPLATE === 'product.custom-bag' ||
    TEMPLATE.endsWith('.custom-bag')
  ) {
    console.info(
      '[Elyra] Personalization disabled on custom-bag'
    );

    return;
  }

  let pending = null;
  let busy = false;

  let standardEventsPromise = null;

  function loadStandardEvents() {
    if (!standardEventsPromise) {
      standardEventsPromise = import(
        'https://cdn.shopify.com/storefront/standard-events.js'
      );
    }

    return standardEventsPromise;
  }

  /*
   * ========================================================
   * POPUP
   * ========================================================
   */

  function createPopup() {
    if (
      document.getElementById(
        'elyra-personalization-popup'
      )
    ) {
      return;
    }

    const style =
      document.createElement('style');

    style.id =
      'elyra-personalization-style';

    style.textContent = `
      #elyra-personalization-popup[hidden] {
        display: none !important;
      }

      #elyra-personalization-popup {
        position: fixed !important;
        inset: 0 !important;

        width: 100vw !important;
        height: 100dvh !important;

        z-index: 2147483647 !important;

        display: flex !important;
        align-items: center !important;
        justify-content: center !important;

        padding: 20px !important;
        box-sizing: border-box !important;

        isolation: isolate !important;
      }

      .elyra-personalization__overlay {
        position: absolute !important;
        inset: 0 !important;

        background:
          radial-gradient(
            circle at 70% 15%,
            rgba(255, 220, 234, 0.24),
            transparent 32%
          ),
          rgba(39, 22, 30, 0.54) !important;

        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
      }

      .elyra-personalization__dialog {
        position: relative !important;
        z-index: 2 !important;

        width:
          min(
            520px,
            calc(100vw - 30px)
          ) !important;

        max-height:
          calc(100dvh - 30px) !important;

        overflow: auto !important;

        padding:
          36px 32px 30px !important;

        box-sizing: border-box !important;

        background:
          linear-gradient(
            180deg,
            #fffafd 0%,
            #ffffff 72%
          ) !important;

        color: #442d37 !important;

        border:
          1px solid
          rgba(226, 169, 191, 0.42) !important;

        border-radius: 28px !important;

        box-shadow:
          0 30px 90px
          rgba(85, 43, 62, 0.20),
          0 8px 26px
          rgba(222, 127, 165, 0.10) !important;

        scrollbar-width: thin;
      }

      .elyra-personalization__dialog::-webkit-scrollbar {
        width: 5px;
      }

      .elyra-personalization__dialog::-webkit-scrollbar-thumb {
        background: #e6b4c7;
        border-radius: 999px;
      }

      .elyra-personalization__bg {
        position: absolute;
        inset: 0;

        overflow: hidden;

        border-radius: 28px;

        pointer-events: none;
      }

      .elyra-personalization__flower {
        position: absolute;

        color: #d987a8;

        opacity: 0.14;

        pointer-events: none;
      }

      .elyra-personalization__flower--top {
        width: 152px;
        height: 152px;

        top: -34px;
        right: -30px;

        transform: rotate(15deg);
      }

      .elyra-personalization__flower--bottom {
        width: 135px;
        height: 135px;

        bottom: -38px;
        left: -34px;

        transform: rotate(-21deg);

        opacity: 0.10;
      }

      .elyra-personalization__leaf {
        position: absolute;

        width: 86px;
        height: 86px;

        right: -8px;
        bottom: 48px;

        color: #e0a4b9;
        opacity: 0.10;

        transform: rotate(15deg);

        pointer-events: none;
      }

      .elyra-personalization__sparkle {
        position: absolute;

        width: 16px;
        height: 16px;

        top: 27px;
        right: 86px;

        color: #e9a5bf;

        opacity: 0.9;

        pointer-events: none;
      }

      .elyra-personalization__sparkle--small {
        width: 9px;
        height: 9px;

        top: 52px;
        right: 72px;

        opacity: 0.65;
      }

      .elyra-personalization__content {
        position: relative;
        z-index: 2;
      }

      .elyra-personalization__close {
        position: absolute !important;

        top: -18px !important;
        right: -14px !important;

        display: flex !important;
        align-items: center !important;
        justify-content: center !important;

        width: 40px !important;
        height: 40px !important;

        padding: 0 !important;

        border:
          1px solid
          rgba(225, 183, 200, 0.58) !important;

        border-radius: 999px !important;

        background:
          rgba(255, 255, 255, 0.88) !important;

        color: #926475 !important;

        box-shadow:
          0 4px 14px
          rgba(126, 80, 98, 0.07) !important;

        font-size: 24px !important;
        font-weight: 300 !important;
        line-height: 1 !important;

        cursor: pointer !important;

        transition:
          background .18s ease,
          color .18s ease,
          transform .18s ease !important;
      }

      .elyra-personalization__close:hover {
        background: #fff !important;
        color: #684453 !important;

        transform:
          rotate(3deg)
          scale(1.04);
      }

      .elyra-personalization__eyebrow {
        display: inline-flex;
        align-items: center;

        gap: 9px;

        margin-bottom: 18px;

        padding: 8px 14px;

        border:
          1px solid
          rgba(230, 182, 201, 0.62);

        border-radius: 999px;

        background:
          linear-gradient(
            180deg,
            rgba(255,255,255,.98),
            rgba(255,241,247,.96)
          );

        color: #ae6481;

        font-size: 11px;
        line-height: 1;
        font-weight: 750;

        letter-spacing: .065em;

        text-transform: uppercase;

        box-shadow:
          0 5px 14px
          rgba(212, 127, 161, 0.07);
      }

      .elyra-personalization__eyebrow-dot {
        display: block;

        width: 8px;
        height: 8px;

        border-radius: 50%;

        background:
          linear-gradient(
            180deg,
            #f5acc8,
            #dd7da3
          );

        box-shadow:
          0 0 0 5px
          rgba(239, 150, 186, 0.13);

        flex-shrink: 0;
      }

      .elyra-personalization__title {
        margin:
          0 48px 14px 0 !important;

        color: #4a303b !important;

        font-size: 31px !important;
        line-height: 1.12 !important;
        font-weight: 720 !important;

        letter-spacing:
          -0.026em !important;
      }

      .elyra-personalization__description {
        margin:
          0 0 22px !important;

        max-width: 430px;

        color: #795f6a !important;

        font-size: 15.5px !important;
        line-height: 1.65 !important;
      }

      .elyra-personalization__highlight {
        position: relative;

        margin-bottom: 24px;

        padding:
          15px 17px 15px 18px;

        border:
          1px solid
          rgba(232, 194, 210, 0.72);

        border-radius: 17px;

        background:
          linear-gradient(
            135deg,
            #fff4f8 0%,
            #fffafd 100%
          );

        color: #805a6a;

        font-size: 14px;
        line-height: 1.55;
      }

      .elyra-personalization__highlight::before {
        content: "✿";

        display: inline-block;

        margin-right: 7px;

        color: #dc83a7;

        font-size: 13px;
      }

      .elyra-personalization__highlight strong {
        color: #b05d7e;
        font-weight: 750;
      }

      .elyra-personalization__actions {
        display: grid !important;

        gap: 11px !important;
      }

      .elyra-personalization__button {
        position: relative;

        width: 100% !important;

        min-height: 54px !important;

        padding:
          14px 18px !important;

        border-radius: 14px !important;

        font: inherit !important;

        font-size: 14.5px !important;
        font-weight: 720 !important;

        cursor: pointer !important;

        transition:
          transform .18s ease,
          box-shadow .18s ease,
          background .18s ease,
          border-color .18s ease,
          opacity .18s ease !important;
      }

      .elyra-personalization__button:hover {
        transform:
          translateY(-1px);
      }

      .elyra-personalization__button--primary {
        border:
          1px solid
          #dc7fa4 !important;

        background:
          linear-gradient(
            180deg,
            #efa0bf 0%,
            #dc7ca3 100%
          ) !important;

        color: #fff !important;

        box-shadow:
          0 10px 24px
          rgba(218, 117, 157, 0.25) !important;
      }

      .elyra-personalization__button--primary:hover {
        background:
          linear-gradient(
            180deg,
            #ed98ba 0%,
            #d9739b 100%
          ) !important;

        box-shadow:
          0 14px 30px
          rgba(218, 117, 157, 0.30) !important;
      }

      .elyra-personalization__button--primary:active {
        transform:
          translateY(0);
      }

      .elyra-personalization__button--secondary {
        border:
          1px solid
          #e4ccd6 !important;

        background:
          rgba(255,255,255,.88) !important;

        color: #785665 !important;
      }

      .elyra-personalization__button--secondary:hover {
        background:
          #fff6fa !important;

        border-color:
          #dab4c4 !important;
      }

      .elyra-personalization__button:disabled {
        opacity:
          .55 !important;

        cursor:
          wait !important;

        transform:
          none !important;
      }

      .elyra-personalization__field {
        margin:
          4px 0 20px !important;
      }

      .elyra-personalization__label {
        display:
          block !important;

        margin-bottom:
          9px !important;

        color:
          #583b48 !important;

        font-size:
          13.5px !important;

        font-weight:
          720 !important;
      }

      #elyra-personalization-text {
        display:
          block !important;

        width:
          100% !important;

        min-height:
          55px !important;

        box-sizing:
          border-box !important;

        padding:
          14px 16px !important;

        border:
          1px solid
          #e2c2cf !important;

        border-radius:
          14px !important;

        background:
          rgba(255,255,255,.95) !important;

        color:
          #4a303b !important;

        font:
          inherit !important;

        font-size:
          15px !important;

        box-shadow:
          inset 0 1px 2px
          rgba(49,27,36,.025) !important;

        transition:
          border-color .18s ease,
          box-shadow .18s ease !important;
      }

      #elyra-personalization-text::placeholder {
        color:
          #b58f9f !important;
      }

      #elyra-personalization-text:focus {
        outline:
          none !important;

        border-color:
          #dc7fa4 !important;

        box-shadow:
          0 0 0 4px
          rgba(228, 128, 168, .14) !important;
      }

      .elyra-personalization__meta {
        display: flex;
        align-items: center;
        justify-content: space-between;

        gap: 10px;

        flex-wrap: wrap;

        margin-top: 10px;
      }

      .elyra-personalization__price {
        display:
          inline-flex !important;

        align-items:
          center !important;

        gap:
          6px !important;

        padding:
          7px 12px !important;

        border:
          1px solid
          #f0d3df;

        border-radius:
          999px !important;

        background:
          #fff1f7 !important;

        color:
          #af5e80 !important;

        font-size:
          12.5px !important;

        font-weight:
          750 !important;
      }

      .elyra-personalization__price::before {
        content:
          "✿";

        font-size:
          11px;
      }

      .elyra-personalization__helper {
        max-width: 260px;

        color:
          #9b7a88;

        font-size:
          12px;

        line-height:
          1.45;
      }

      .elyra-personalization__error {
        margin:
          0 0 16px !important;

        padding:
          12px 14px !important;

        border:
          1px solid
          #f0ccd6 !important;

        border-radius:
          12px !important;

        background:
          #fff4f6 !important;

        color:
          #a33844 !important;

        font-size:
          13px !important;

        line-height:
          1.45 !important;
      }

      @media (
        max-width: 749px
      ) {
        #elyra-personalization-popup {
          align-items:
            flex-end !important;

          padding:
            8px !important;
        }

        .elyra-personalization__dialog {
          width:
            100% !important;

          max-height:
            calc(100dvh - 10px) !important;

          padding:
            28px 20px 20px !important;

          border-radius:
            24px !important;
        }

        .elyra-personalization__bg {
          border-radius:
            24px;
        }

        .elyra-personalization__title {
          margin-right:
            44px !important;

          font-size:
            26px !important;
        }

        .elyra-personalization__description {
          font-size:
            14.5px !important;
        }

        .elyra-personalization__flower--top {
          width:
            112px;

          height:
            112px;
        }

        .elyra-personalization__flower--bottom {
          width:
            95px;

          height:
            95px;
        }

        .elyra-personalization__highlight {
          padding:
            13px 14px;
        }

        .elyra-personalization__meta {
          align-items:
            flex-start;

          flex-direction:
            column;
        }

        .elyra-personalization__helper {
          max-width:
            none;
        }
      }
    `;

    document.head.appendChild(
      style
    );

    const popup =
      document.createElement(
        'div'
      );

    popup.id =
      'elyra-personalization-popup';

    popup.hidden =
      true;

    popup.innerHTML = `
      <div
        class="elyra-personalization__overlay"
        data-elyra-close
      ></div>

      <div
        class="elyra-personalization__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="elyra-personalization-title"
      >
        <div
          class="elyra-personalization__bg"
          aria-hidden="true"
        >

          <svg
            class="
              elyra-personalization__flower
              elyra-personalization__flower--top
            "
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              fill="currentColor"
            >
              <ellipse
                cx="60"
                cy="23"
                rx="13"
                ry="25"
              />

              <ellipse
                cx="60"
                cy="97"
                rx="13"
                ry="25"
              />

              <ellipse
                cx="23"
                cy="60"
                rx="25"
                ry="13"
              />

              <ellipse
                cx="97"
                cy="60"
                rx="25"
                ry="13"
              />

              <ellipse
                cx="35"
                cy="35"
                rx="14"
                ry="22"
                transform="rotate(-45 35 35)"
              />

              <ellipse
                cx="85"
                cy="35"
                rx="14"
                ry="22"
                transform="rotate(45 85 35)"
              />

              <ellipse
                cx="35"
                cy="85"
                rx="14"
                ry="22"
                transform="rotate(45 35 85)"
              />

              <ellipse
                cx="85"
                cy="85"
                rx="14"
                ry="22"
                transform="rotate(-45 85 85)"
              />
            </g>

            <circle
              cx="60"
              cy="60"
              r="12"
              fill="#eba6bf"
            />
          </svg>

          <svg
            class="
              elyra-personalization__flower
              elyra-personalization__flower--bottom
            "
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              fill="currentColor"
            >
              <ellipse
                cx="60"
                cy="23"
                rx="13"
                ry="25"
              />

              <ellipse
                cx="60"
                cy="97"
                rx="13"
                ry="25"
              />

              <ellipse
                cx="23"
                cy="60"
                rx="25"
                ry="13"
              />

              <ellipse
                cx="97"
                cy="60"
                rx="25"
                ry="13"
              />

              <ellipse
                cx="35"
                cy="35"
                rx="14"
                ry="22"
                transform="rotate(-45 35 35)"
              />

              <ellipse
                cx="85"
                cy="35"
                rx="14"
                ry="22"
                transform="rotate(45 85 35)"
              />

              <ellipse
                cx="35"
                cy="85"
                rx="14"
                ry="22"
                transform="rotate(45 35 85)"
              />

              <ellipse
                cx="85"
                cy="85"
                rx="14"
                ry="22"
                transform="rotate(-45 85 85)"
              />
            </g>

            <circle
              cx="60"
              cy="60"
              r="12"
              fill="#eba6bf"
            />
          </svg>

          <svg
            class="elyra-personalization__leaf"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="
                M15 83
                C35 55 48 36 85 17
                C74 52 54 74 15 83Z
              "
              fill="currentColor"
            />

            <path
              d="
                M22 77
                C43 62 58 47 78 27
              "
              stroke="#cf7f9d"
              stroke-width="2"
              fill="none"
            />
          </svg>

          <svg
            class="elyra-personalization__sparkle"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="
                M8 0
                L9.7 6.3
                L16 8
                L9.7 9.7
                L8 16
                L6.3 9.7
                L0 8
                L6.3 6.3
                Z
              "
              fill="currentColor"
            />
          </svg>

          <svg
            class="
              elyra-personalization__sparkle
              elyra-personalization__sparkle--small
            "
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="
                M8 0
                L9.7 6.3
                L16 8
                L9.7 9.7
                L8 16
                L6.3 9.7
                L0 8
                L6.3 6.3
                Z
              "
              fill="currentColor"
            />
          </svg>

        </div>

        <div
          class="elyra-personalization__content"
        >

          <button
            type="button"
            class="elyra-personalization__close"
            data-elyra-close
            aria-label="Închide"
          >
            ×
          </button>

          <div
            data-elyra-step="choice"
          >

            <div
              class="elyra-personalization__eyebrow"
            >
              <span
                class="elyra-personalization__eyebrow-dot"
              ></span>

              Personalizare disponibilă
            </div>

            <h2
              id="elyra-personalization-title"
              class="elyra-personalization__title"
            >
              Vrei un produs unic?
            </h2>

            <p
              class="elyra-personalization__description"
            >
              Adaugă o notă personală și transformă produsul într-o piesă făcută special pentru tine sau pentru cineva drag.
            </p>

            <div
              class="elyra-personalization__highlight"
            >
              <strong>
                Putem broda
              </strong>

              numele, inițialele sau un text scurt preferat, pentru un rezultat delicat și personal.
            </div>

            <div
              class="elyra-personalization__actions"
            >

              <button
                type="button"
                class="
                  elyra-personalization__button
                  elyra-personalization__button--primary
                "
                data-elyra-yes
              >
                Da, vreau personalizare!
              </button>

              <button
                type="button"
                class="
                  elyra-personalization__button
                  elyra-personalization__button--secondary
                "
                data-elyra-no
              >
                Continuă fără personalizare
              </button>

            </div>

          </div>

          <div
            data-elyra-step="details"
            hidden
          >

            <div
              class="elyra-personalization__eyebrow"
            >
              <span
                class="elyra-personalization__eyebrow-dot"
              ></span>

              Detalii broderie
            </div>

            <h2
              class="elyra-personalization__title"
            >
              Personalizează produsul
            </h2>

            <p
              class="elyra-personalization__description"
            >
              Scrie textul dorit, iar noi îl vom pregăti cu grijă în stilul delicat Elyra.
            </p>

            <div
              class="elyra-personalization__field"
            >

              <label
                class="elyra-personalization__label"
                for="elyra-personalization-text"
              >
                Textul dorit
              </label>

              <input
                id="elyra-personalization-text"
                type="text"
                maxlength="80"
                autocomplete="off"
                placeholder="Ex: Maria, A.M."
              >

              <div
                class="elyra-personalization__meta"
              >

                <span
                  class="elyra-personalization__price"
                >
                  +10 lei
                </span>

                <span
                  class="elyra-personalization__helper"
                >
                  Recomandat: nume, inițiale sau un text scurt.
                </span>

              </div>

            </div>

            <div
              class="elyra-personalization__error"
              data-elyra-error
              hidden
            ></div>

            <div
              class="elyra-personalization__actions"
            >

              <button
                type="button"
                class="
                  elyra-personalization__button
                  elyra-personalization__button--primary
                "
                data-elyra-confirm
              >
                Adaugă personalizarea (+10 lei)
              </button>

              <button
                type="button"
                class="
                  elyra-personalization__button
                  elyra-personalization__button--secondary
                "
                data-elyra-back
              >
                Înapoi
              </button>

            </div>

          </div>

        </div>
      </div>
    `;

    document.body.appendChild(
      popup
    );
  }

  function getPopup() {
    return document.getElementById(
      'elyra-personalization-popup'
    );
  }

  function clearError() {
    const el =
      getPopup()?.querySelector(
        '[data-elyra-error]'
      );

    if (!el) return;

    el.hidden = true;
    el.textContent = '';
  }

  function showError(message) {
    const el =
      getPopup()?.querySelector(
        '[data-elyra-error]'
      );

    if (!el) return;

    el.textContent =
      message;

    el.hidden =
      false;
  }

  function setBusy(state) {
    busy =
      state;

    const root =
      getPopup();

    if (!root) return;

    root
      .querySelectorAll(
        'button'
      )
      .forEach(
        button => {
          button.disabled =
            state;
        }
      );

    const confirm =
      root.querySelector(
        '[data-elyra-confirm]'
      );

    if (confirm) {
      confirm.textContent =
        state
          ? 'Se adaugă...'
          : 'Adaugă personalizarea (+10 lei)';
    }
  }

  function openPopup(context) {
    pending =
      context;

    const root =
      getPopup();

    if (!root) {
      return;
    }

    clearError();
    setBusy(false);

    root.querySelector(
      '[data-elyra-step="choice"]'
    ).hidden =
      false;

    root.querySelector(
      '[data-elyra-step="details"]'
    ).hidden =
      true;

    root.querySelector(
      '#elyra-personalization-text'
    ).value =
      '';

    root.hidden =
      false;

    document
      .documentElement
      .style
      .overflow =
      'hidden';

    requestAnimationFrame(
      () => {
        root
          .querySelector(
            '[data-elyra-yes]'
          )
          ?.focus();
      }
    );
  }

  function closePopup() {
    const root =
      getPopup();

    if (!root) {
      return;
    }

    root.hidden =
      true;

    document
      .documentElement
      .style
      .overflow =
      '';

    clearError();
    setBusy(false);
  }

  /*
   * ========================================================
   * PRODUCT DATA
   * ========================================================
   */

  function collectProperties(
    formData
  ) {
    const properties =
      {};

    for (
      const [key, value]
      of formData.entries()
    ) {
      const match =
        key.match(
          /^properties\[(.+)\]$/
        );

      if (
        !match ||
        typeof value !==
          'string' ||
        !value.trim()
      ) {
        continue;
      }

      properties[
        match[1]
      ] =
        value;
    }

    return properties;
  }

  function contextFromForm(
    component,
    form
  ) {
    if (
      !component ||
      !form
    ) {
      return null;
    }

    if (
      !form.checkValidity()
    ) {
      form.reportValidity();

      return null;
    }

    const formData =
      new FormData(
        form
      );

    const variantId =
      Number(
        formData.get(
          'id'
        ) ||
        component
          .querySelector(
            '[name="id"]'
          )
          ?.value ||
        0
      );

    if (
      !variantId ||
      variantId ===
        ADDON_VARIANT_ID
    ) {
      return null;
    }

    let quantity =
      Number(
        component
          .refs
          ?.quantitySelector
          ?.getValue?.()
      ) ||
      Number(
        formData.get(
          'quantity'
        )
      ) ||
      Number(
        component
          .dataset
          .quantityDefault
      ) ||
      1;

    if (
      !Number.isFinite(
        quantity
      ) ||
      quantity < 1
    ) {
      quantity =
        1;
    }

    const sellingPlanRaw =
      formData.get(
        'selling_plan'
      );

    return {
      source:
        component,

      component,
      form,

      productId:
        String(
          component
            .dataset
            .productId ||
          ''
        ),

      variantId,
      quantity,

      properties:
        collectProperties(
          formData
        ),

      sellingPlan:
        sellingPlanRaw
          ? Number(
              sellingPlanRaw
            )
          : null
    };
  }

  function contextFromSticky(
    sticky
  ) {
    const productId =
      String(
        sticky
          ?.dataset
          .productId ||
        ''
      );

    if (!productId) {
      return null;
    }

    const section =
      sticky.closest(
        '.shopify-section'
      );

    let component =
      section
        ?.querySelector(
          `product-form-component[data-product-id="${productId}"]`
        );

    if (!component) {
      component =
        document.querySelector(
          `product-form-component[data-product-id="${productId}"]`
        );
    }

    const form =
      component
        ?.querySelector(
          'form'
        );

    const fromForm =
      contextFromForm(
        component,
        form
      );

    if (fromForm) {
      fromForm.source =
        sticky;

      return fromForm;
    }

    const variantId =
      Number(
        sticky
          .dataset
          .currentVariantId ||
        0
      );

    if (
      !variantId ||
      variantId ===
        ADDON_VARIANT_ID
    ) {
      return null;
    }

    let quantity =
      Number(
        sticky
          .dataset
          .initialQuantity ||
        1
      );

    if (
      !Number.isFinite(
        quantity
      ) ||
      quantity < 1
    ) {
      quantity =
        1;
    }

    return {
      source:
        sticky,

      component:
        null,

      form:
        null,

      productId,
      variantId,
      quantity,

      properties:
        {},

      sellingPlan:
        null
    };
  }

  /*
   * ========================================================
   * CART
   * ========================================================
   */

  function cartSectionIds() {
    return [
      ...new Set(
        [
          ...document
            .querySelectorAll(
              'cart-items-component[data-section-id]'
            )
        ]
          .map(
            el =>
              el
                .dataset
                .sectionId
          )
          .filter(
            Boolean
          )
      )
    ];
  }

  async function fetchCart() {
    const response =
      await fetch(
        '/cart.js',
        {
          credentials:
            'same-origin',

          headers: {
            Accept:
              'application/json'
          }
        }
      );

    if (
      !response.ok
    ) {
      throw new Error(
        'Coșul nu a putut fi actualizat.'
      );
    }

    return response.json();
  }

  async function notifyHorizon(
    context,
    items,
    result,
    cart
  ) {
    try {
      const {
        CartLinesUpdateEvent
      } =
        await loadStandardEvents();

      const deferred =
        CartLinesUpdateEvent
          .createPromise();

      const source =
        context.source ||
        context.component ||
        document.body;

      source.dispatchEvent(
        new CartLinesUpdateEvent({
          action:
            'add',

          context:
            'product',

          lines:
            items.map(
              item => ({
                merchandiseId:
                  String(
                    item.id
                  ),

                quantity:
                  item.quantity
              })
            ),

          promise:
            deferred.promise
        })
      );

      deferred.resolve({
        cart:
          CartLinesUpdateEvent
            .createCartFromAjaxResponse(
              cart
            ),

        detail: {
          items:
            cart.items,

          source:
            'elyra-personalization',

          sourceId:
            'elyra-personalization',

          itemCount:
            context.quantity,

          productId:
            context.productId,

          sections:
            result.sections ||
            {},

          didError:
            false
        }
      });

    } catch (error) {
      console.error(
        '[Elyra] Horizon sync failed',
        error
      );

      window.location.href =
        '/cart';
    }
  }

  async function addToCart(
    personalized
  ) {
    if (
      !pending ||
      busy
    ) {
      return;
    }

    const context =
      pending;

    const root =
      getPopup();

    const text =
      String(
        root
          ?.querySelector(
            '#elyra-personalization-text'
          )
          ?.value ||
        ''
      ).trim();

    if (
      personalized &&
      !text
    ) {
      showError(
        'Completează textul dorit.'
      );

      root
        ?.querySelector(
          '#elyra-personalization-text'
        )
        ?.focus();

      return;
    }

    setBusy(
      true
    );

    clearError();

    /*
     * PRODUS PRINCIPAL
     */

    const mainProperties = {
      ...context.properties
    };

    if (
      personalized
    ) {
      mainProperties
        .Personalizare =
        text;
    }

    const mainItem = {
      id:
        context.variantId,

      quantity:
        context.quantity
    };

    if (
      Object.keys(
        mainProperties
      ).length
    ) {
      mainItem.properties =
        mainProperties;
    }

    if (
      context.sellingPlan
    ) {
      mainItem.selling_plan =
        context.sellingPlan;
    }

    const items = [
      mainItem
    ];

    /*
     * ADDON 10 LEI
     */

    if (
      personalized
    ) {
      items.push({
        id:
          ADDON_VARIANT_ID,

        quantity:
          context.quantity,

        properties: {
          '_Tip':
            'Personalizare broderie',

          '_Variant produs':
            String(
              context.variantId
            ),

          '_Text personalizare':
            text
        }
      });
    }

    const payload = {
      items
    };

    const sections =
      cartSectionIds();

    if (
      sections.length
    ) {
      payload.sections =
        sections.join(',');
    }

    try {
      const response =
        await fetch(
          '/cart/add.js',
          {
            method:
              'POST',

            credentials:
              'same-origin',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body:
              JSON.stringify(
                payload
              )
          }
        );

      const result =
        await response.json();

      if (
        !response.ok ||
        result?.status
      ) {
        throw new Error(
          result?.description ||
          result?.message ||
          'Produsul nu a putut fi adăugat în coș.'
        );
      }

      const cart =
        await fetchCart();

      /*
       * Popup-ul dispare ÎNAINTE
       * să lăsăm Horizon să deschidă drawer-ul.
       */
      closePopup();

      pending =
        null;

      await notifyHorizon(
        context,
        items,
        result,
        cart
      );

      console.info(
        '[Elyra] Added',
        {
          personalized,

          variantId:
            context.variantId,

          quantity:
            context.quantity
        }
      );

    } catch (error) {
      console.error(
        '[Elyra] Add failed',
        error
      );

      showError(
        error?.message ||
        'A apărut o eroare. Încearcă din nou.'
      );

      setBusy(
        false
      );
    }
  }

  /*
   * ========================================================
   * INTERCEPT ADD TO CART
   * ========================================================
   */

  function captureAddClick(
    event
  ) {
    if (
      busy
    ) {
      return;
    }

    const target =
      event.target;

    if (
      !(
        target instanceof
        Element
      )
    ) {
      return;
    }

    const button =
      target.closest(
        'button'
      );

    if (
      !button ||
      button.closest(
        '#elyra-personalization-popup'
      )
    ) {
      return;
    }

    /*
     * NORMAL / QUICK ADD
     */

    const component =
      button.closest(
        'product-form-component'
      );

    const normalAdd =
      component &&
      button.matches(
        'button[type="submit"][name="add"]'
      );

    if (
      normalAdd
    ) {
      const form =
        button.closest(
          'form'
        ) ||
        component.querySelector(
          'form'
        );

      const context =
        contextFromForm(
          component,
          form
        );

      if (
        !context
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      openPopup(
        context
      );

      return;
    }

    /*
     * STICKY ADD TO CART
     */

    const sticky =
      button.closest(
        'sticky-add-to-cart'
      );

    const stickyAdd =
      sticky &&
      button.matches(
        '.sticky-add-to-cart__button'
      );

    if (
      !stickyAdd
    ) {
      return;
    }

    const context =
      contextFromSticky(
        sticky
      );

    if (
      !context
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    openPopup(
      context
    );
  }

  /*
   * ========================================================
   * POPUP EVENTS
   * ========================================================
   */

  function bindPopupEvents() {
    document.addEventListener(
      'click',
      event => {
        const target =
          event.target;

        if (
          !(
            target instanceof
            Element
          )
        ) {
          return;
        }

        const root =
          getPopup();

        if (
          !root
        ) {
          return;
        }

        /*
         * YES
         */

        if (
          target.closest(
            '[data-elyra-yes]'
          )
        ) {
          clearError();

          root.querySelector(
            '[data-elyra-step="choice"]'
          ).hidden =
            true;

          root.querySelector(
            '[data-elyra-step="details"]'
          ).hidden =
            false;

          requestAnimationFrame(
            () => {
              root
                .querySelector(
                  '#elyra-personalization-text'
                )
                ?.focus();
            }
          );

          return;
        }

        /*
         * CONTINUĂ FĂRĂ PERSONALIZARE
         */

        if (
          target.closest(
            '[data-elyra-no]'
          )
        ) {
          addToCart(
            false
          );

          return;
        }

        /*
         * CONFIRM PERSONALIZARE
         */

        if (
          target.closest(
            '[data-elyra-confirm]'
          )
        ) {
          addToCart(
            true
          );

          return;
        }

        /*
         * BACK
         */

        if (
          target.closest(
            '[data-elyra-back]'
          )
        ) {
          clearError();

          root.querySelector(
            '[data-elyra-step="details"]'
          ).hidden =
            true;

          root.querySelector(
            '[data-elyra-step="choice"]'
          ).hidden =
            false;

          return;
        }

        /*
         * CLOSE
         */

        if (
          target.closest(
            '[data-elyra-close]'
          ) &&
          !busy
        ) {
          pending =
            null;

          closePopup();
        }
      }
    );

    document.addEventListener(
      'keydown',
      event => {
        const root =
          getPopup();

        if (
          !root ||
          root.hidden
        ) {
          return;
        }

        if (
          event.key ===
            'Escape' &&
          !busy
        ) {
          pending =
            null;

          closePopup();

          return;
        }

        if (
          event.key ===
            'Enter' &&
          document
            .activeElement
            ?.id ===
            'elyra-personalization-text'
        ) {
          event.preventDefault();

          addToCart(
            true
          );
        }
      }
    );
  }

  /*
   * ========================================================
   * INIT
   * ========================================================
   */

  function init() {
    createPopup();

    window.addEventListener(
      'click',
      captureAddClick,
      true
    );

    bindPopupEvents();

    document
      .documentElement
      .dataset
      .elyraPersonalization =
      'loaded';

    console.info(
      '[Elyra] Personalization loaded',
      {
        addonVariantId:
          ADDON_VARIANT_ID,

        template:
          TEMPLATE
      }
    );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once: true
      }
    );
  } else {
    init();
  }
})();